<template>
  <div id="app">
    <el-container class="el_app">
      <el-header>
        <div class="dis_between">
          <div class="dis">
            <img class="head_img" src="../../assets/logo2.png" alt="" />
            <div>后台管理系统</div>
          </div>

          <el-dropdown trigger="click" @command="handleCommand_btn()">
            <div class="dis user_detail">
              <img class="user_img" src="../../assets/4.png" alt="" />
              <div class="name">{{ userInfo.realName }}</div>
              <img class="loginout_img" src="../../assets/5.png" alt="" />
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item icon="el-icon-switch-button" command="Logout">
                <span style="margin-left: 0">退出登录</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>
      <el-container>
        <el-aside width="140rem">
          <el-menu :default-active="active_index" class="el-menu-vertical-demo" @select="headleSelect"
            @open="handleOpen" @close="handleClose" background-color="#fff" text-color="#303133"
            active-text-color="#C1272D">

            <div class="dis menu_list">
              <el-menu-item index="0">
                <img v-if="active_index == 0" src="../../assets/tabbar/21.png" class="img_menu" alt="" />
                <img v-else src="../../assets/tabbar/11.png" class="img_menu" alt="" />
                <span slot="title">首页</span>
              </el-menu-item>
            </div>
            <div class="dis menu_list">
              <el-menu-item index="1">
                <img v-if="active_index == 1" src="../../assets/tabbar/22.png" class="img_menu" alt="" />
                <img v-else src="../../assets/tabbar/12.png" class="img_menu" alt="" />
                <span slot="title">用户管理</span>
              </el-menu-item>
            </div>
            <div class="dis menu_list">
              <el-menu-item index="31">
                <img v-if="active_index == 31" src="../../assets/tabbar/32.png" class="img_menu" alt="" />
                <img v-else src="../../assets/tabbar/13.png" class="img_menu" alt="" />
                <span slot="title">项目管理</span>
              </el-menu-item>
            </div>
            <div class="dis menu_list">
              <el-menu-item index="33">
                <img v-if="active_index == 33" src="../../assets/tabbar/42.png" class="img_menu" alt="" />
                <img v-else src="../../assets/tabbar/14.png" class="img_menu" alt="" />
                <span slot="title">客户管理</span>
              </el-menu-item>
            </div>
            <div class="dis menu_list">
              <el-menu-item index="43">
                <img v-if="active_index == 43" src="../../assets/tabbar/52.png" class="img_menu" alt="" />
                <img v-else src="../../assets/tabbar/15.png" class="img_menu" alt="" />
                <span slot="title">人员管理</span>
              </el-menu-item>
            </div>
            <div class="dis menu_list">
              <el-menu-item index="25">
                <img v-if="active_index == 25" src="../../assets/tabbar/62.png" class="img_menu" alt="" />
                <img v-else src="../../assets/tabbar/16.png" class="img_menu" alt="" />
                <span slot="title">订单管理</span>
              </el-menu-item>
            </div>
            <div class="dis menu_list">
              <el-menu-item index="11">
                <img v-if="active_index == 11" src="../../assets/tabbar/72.png" class="img_menu" alt="" />
                <img v-else src="../../assets/tabbar/17.png" class="img_menu" alt="" />
                <span slot="title">账号管理</span>
              </el-menu-item>
            </div>
          </el-menu>
        </el-aside>
        <el-main>
          <keep-alive>
            <router-view v-if="$route.meta.keepAlive" />
          </keep-alive>
          <router-view v-if="!$route.meta.keepAlive" />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { api, img_url, login } from "../js/api";
export default {
  data() {
    return {
      // admin_type:1,//再回头
      admin_type: 2, //好食汇
      api: "",
      img_url: "",
      active_index: "0",
      userName: "admin",
      userInfo: {},
      userType: 1, //账号分类：1超管2学校3老师
      navConfig: {
        home: "0",
        userManagement: "1",
        HomeworkManagement: "2",
        schoolManagement: "3",
        returnReview: "4",
        rechargeManagement: "5",
        storManagement: "6",
        FontLibraryManagement: "7",
        couponType: "8",
        voucherVerification: "9",
        Feedback: "10",
        accountManagement: "11",
        writeoffStatistics: "12",
        AttendanceVoucherManagement: "13",
        companyMananement: "14",
        LiveStatistics: "15",
        RechargeReview: "16",
        liveRoomManagement: "17",
        orderStatistics: "18",
        LogisticsInformation: "19",
        storeAudit: "20",
        InvestmentManagement: "21",
        bannerManagement: "22",
        CodeLayingManagement: "23",
        xcxLiveRoomManagement: "24",
        orderManagement: "25",
        CategoryManagement: "26",
        batchManagement: "27",
        CommissionAllocationSettings: "28",
        ExchangeGoods: "29",
        WithdrawalReview: "30",
        projectManagement: "31",
        LibraryManagement: "32",
        MembershipSettings: "33",
        PointsDetails: "34",
        MicroPage: "35",
        UserRanking: "36",
        dataStatistics: "37",
        TransactionStatistics: "38",
        ProxyOrder: "39",
        LibraryManagement: "40",
        newOrders: "41",
        CommissionDetails: "42",
        PersonnelManagement: "43",
        ConfigureDurationCoupons: "44"
      },
    };
  },
  created() {
    let that = this;
    that.api = api;
    that.img_url = img_url;
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    that.userInfo = userInfo;
    that.userType = userInfo ? userInfo.userType : 1;
    console.log("v--------", userInfo);
    console.log("userType:", that.userType);
    // console.log(userInfo);
  },
  mounted() {
    //刷新返显列表所选页
    let _this = this;
    let href = window.location.href;
    href = href.split("/#/")[1];
    //console.log(href, _this.navConfig, _this.navConfig[href]);
    _this.active_index = _this.navConfig[href];
  },
  watch: {
    $route(to, from) {
      let _this = this;
      let href = window.location.href;
      href = href.split("#/")[1];
      //携带参数分割
      href = href.split("?")[0];
      // console.log(href);
      _this.active_index = _this.navConfig[href];
      // console.log(_this.active_index);
      // _this.select_catalog2 = _this.navConfig[href][0];
    },
  },
  methods: {
    ajaxload() {
      let that = this;
      let json = {};
      json.pageReq = {
        pageNumber: that.pageNumber,
        pageSize: that.pageSize,
      };
      json.entityParam = {};
      login(json).then((res) => {
        //console.log(res);
        if (res.code == 200) {
          that.tableData = res.data.records;
          that.total = Number(res.data.total);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    headleSelect(key, keyPath) {
      let that = this;
      that.active_index = key;
      // console.log(key, keyPath);

      switch (key) {
        case "0":
          that.$router.push("/home");
          break;
        case "1":
          that.$router.push("/userManagement");
          break;
        case "2":
          that.$router.push("/HomeworkManagement");
          break;
        case "3":
          that.$router.push("/schoolManagement");
          break;
        case "4":
          that.$router.push("/returnReview");
          break;
        case "5":
          that.$router.push("/rechargeManagement");
          break;
        case "6":
          that.$router.push("/storManagement");
          break;
        case "7":
          that.$router.push("/FontLibraryManagement");
          break;
        case "8":
          that.$router.push("/couponType");
          break;
        case "9":
          that.$router.push("/voucherVerification");
          break;
        case "10":
          that.$router.push("/Feedback");
          break;
        case "11":
          that.$router.push("/accountManagement");
          break;
        case "12":
          that.$router.push("/writeoffStatistics");
          break;
        case "13":
          that.$router.push("/AttendanceVoucherManagement");
          break;
        case "14":
          that.$router.push("/companyMananement");
          break;
        case "15":
          that.$router.push("/LiveStatistics");
          break;
        case "16":
          that.$router.push("/RechargeReview");
          break;
        case "17":
          that.$router.push("/liveRoomManagement");
          break;
        case "18":
          that.$router.push("/orderStatistics");
          break;
        case "19":
          that.$router.push("/LogisticsInformation");
          break;
        case "20":
          that.$router.push("/storeAudit");
          break;
        case "21":
          that.$router.push("/InvestmentManagement");
          break;
        case "22":
          that.$router.push("/bannerManagement");
          break;
        case "23":
          that.$router.push("/CodeLayingManagement");
          break;
        case "24":
          that.$router.push("/xcxLiveRoomManagement");
          break;
        case "25":
          that.$router.push("/orderManagement");
          break;
        case "26":
          that.$router.push("/CategoryManagement");
          break;
        case "27":
          that.$router.push("/batchManagement");
          break;
        case "28":
          that.$router.push("/CommissionAllocationSettings");
          break;
        case "29":
          that.$router.push("/ExchangeGoods");
          break;
        case "30":
          that.$router.push("/WithdrawalReview");
          break;
        case "31":
          that.$router.push("/projectManagement");
          break;
        case "32":
          that.$router.push("/LibraryManagement");
          break;
        case "33":
          that.$router.push("/MembershipSettings");
          break;
        case "34":
          that.$router.push("/PointsDetails");
          break;
        case "35":
          that.$router.push("/MicroPage");
          break;
        case "36":
          that.$router.push("/UserRanking");
          break;
        case "37":
          that.$router.push("/dataStatistics");
          break;
        case "38":
          that.$router.push("/TransactionStatistics");
          break;
        case "39":
          that.$router.push("/ProxyOrder");
          break;
        case "40":
          that.$router.push("/LibraryManagement");
          break;
        case "41":
          that.$router.push("/newOrders");
          break;
        case "42":
          that.$router.push("/CommissionDetails");
          break;
        case "43":
          that.$router.push("/PersonnelManagement");
          break;
        case "44":
          that.$router.push("/ConfigureDurationCoupons");
          break;
      }
    },
    handleCommand_btn() {
      localStorage.removeItem("id");
      localStorage.removeItem("loginToken");
      localStorage.removeItem("account");
      localStorage.removeItem("password");
      this.$router.replace("/");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("./master.css");
</style>



// WEBPACK FOOTER //
// src/view/master/master.vue